import React from "react";
import { connect } from "react-redux";
import { Button, Card, CardBody, CardHeader, Col, Row } from "reactstrap";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import { Field, reduxForm, change } from "redux-form";
import "react-dropdown/style.css";
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete/Autocomplete";
import _ from "lodash";
import {bindActionCreators} from "redux";

import renderSelectField from '../../../shared/components/form/Select';
import { loadCollections } from "../../../redux/actions/collections";
import { setExecutionType } from "../../../redux/actions/inferenceActions";

let nodeTable = null;

const validate = values => {
  const errors = {};
  if (!values.name) {
    errors.name = "Please enter the Job Description name";
  }
  return errors;
};

const facilitySearchHandler = (e, loadCollections) => {
  loadCollections({collection_name: e.target.value});
};

const EXECUTION_TYPE_OPTIONS = [
  { value: 'ON_DEMAND', label: 'ON_DEMAND' },
  { value: 'CONTINUOUS', label: 'CONTINUOUS' },
];

const renderAutocomplete = ({t, collections, input, loadCollections, onLabelItemSelect}) => {
  return (
    <Autocomplete
      options={_.map(collections, input.name)}
      className='auto-complete-input'
      style={{ width: 440 }}
      value={input.value}
      onChange={(e, values)=> {
        input.onChange(values);
        onLabelItemSelect(values);
        if(!values) {
          loadCollections();
        }
      }}
      name={input.name}
      renderInput={params => {
        return (
          <TextField
            {...params}
            fullWidth
            variant="outlined"
            onChange={e => facilitySearchHandler(e, loadCollections)}
          />
        )}}
    />
  );
}

const renderField =
  ({
     input, placeholder, type, meta: { touched, error },
   }) => (
    <div className="form__form-group-input-wrap form__form-group-input-wrap--error-above">
      <input {...input} placeholder={placeholder} type={type} />
      {touched && error && <span className="form__form-group-error">{error}</span>}
    </div>
  );

renderField.propTypes = {
  input: PropTypes.shape().isRequired,
  placeholder: PropTypes.string,
  type: PropTypes.string,
  meta: PropTypes.shape({
    touched: PropTypes.bool,
    error: PropTypes.string,
  }),
};

renderField.defaultProps = {
  placeholder: '',
  meta: null,
  type: 'text',
};

let InferenceForm = props => {
  const {
    handleSubmit, submitting, initialValues, collections, loadCollections,
    t, hasInference, setExecutionType,
    alModels,
  } = props;

  const DATA_STATUS_OPTIONS = [
    { value: 'FULL_RECEIVING', label: 'FULL RECEIVING' },
    { value: 'LARGE_MISSES', label: 'LARGE MISSES' },
    { value: 'LITTLE_MISSES', label: 'LITTLE MISSES' },
    { value: 'NOT_RECEIVING', label: 'NOT RECEIVING' },
  ];
  const ACTIVITY_STATUS_OPTIONS = [
    { value: 'ACTIVE', label: 'Active' },
    { value: 'OUT_OF_SERVICE', label: 'Out Of Service' },
    { value: 'DOWN', label: 'Down' },
  ];

  const STORAGE_TYPE_OPTIONS = [
    { value: 'LOCAL', label: 'LOCAL' },
    { value: 'AWS_EBS', label: 'AWS_EBS' },
    { value: 'AWS_EFS', label: 'AWS_EFS' },
    { value: 'AWS_S3', label: 'AWS_S3' },
    { value: 'AWS', label: 'AWS' }
  ];

  const options = {
    searchPosition: 'left'
  };

  const selectList = (row, isSelect, rowIndex, e) => {
    if(isSelect){
      checkList.push(rowIndex)
    } else {
      checkList.slice(rowIndex)
    }
  };
  const checkList = _.map(initialValues.ai_model_list, '_id') || [];
  const selectRowProp = {
    mode: 'checkbox',
    selected: checkList,
    onSelect: selectList

  };

  const onLabelItemSelect = (collection_name) => {
    const collection = _.find(collections, ['collection_name', collection_name])
    if (collection && collection._id) {
      props.getAiModelsInference({collection_id: collection._id});
    }
  }


  const onHandleSubmit = (data) => {
    const aiModel = _.filter(alModels, i => {return nodeTable.state.selectedRowKeys.includes(i._id)})
    props.setAiModel(aiModel)
    handleSubmit(data);
  };


  function onItemSelect(res, row)  {
    const data = {...row, execution_type: res.value };
    setExecutionType(data)
  };

  const renderExecutionSelect = (cell, row) => {
    return(
      <Field
        component={renderSelectField}
        name={`execution_type${row._id}`}
        type="select"
        value={cell}
        options={EXECUTION_TYPE_OPTIONS}
        onChange={(res) => onItemSelect(res,row)}
      />
    );
  };

  const renderMonitoringWindow = (cell, row) => {
    return(
      <div className="table-input-wrapper">
        <Field
          name={`monitoring_window${row._id}`}
          component={renderField}
          type="text"
          value={cell}
        />
      </div>
    );
  };

  return (
    <Card className="a-height">
      <form onSubmit={onHandleSubmit}>

        <CardHeader>
          <Row>
            <Col md={6}>
              { hasInference
                ? t('inference_services.create_update_inference.form_update_title')
                : t('inference_services.create_update_inference.form_create_title')
              }
            </Col>
          </Row>
        </CardHeader>
        <CardBody>
          <Row>
            <Col xs="12" sm="5" className="form" >
              <div className="form__form-group">
                <span className="form__form-group-label">
                  {t('inference_services.inference_label.name')}
                </span>
                <div className="form__form-group-field">
                  <Field
                    name="inference_name"
                    component={renderField}
                    type="text"
                  />
                </div>
              </div>

              <div className="form__form-group">
                <span className="form__form-group-label">
                  {t('inference_services.inference_label.deployment_base_location')}
                </span>
                <div className="form__form-group-field">
                  <Field
                    name="baseLocation"
                    component={renderField}
                    type="text"
                  />
                </div>
              </div>
              <div className="form__form-group">
                <span className="form__form-group-label">
                  {t('inference_services.inference_label.organization_path_name')}
                </span>
                <div className="form__form-group-field">
                  <Field
                    component={renderField}
                    name="organizationPathName"
                    type="select"
                    options={DATA_STATUS_OPTIONS}
                  />
                </div>
              </div>
              <div className="form__form-group">
                <span className="form__form-group-label">
                  {t('inference_services.inference_label.data_missing_interval')}
                </span>
                <div className="form__form-group-field">
                  <Field
                    component={renderField}
                    name="dataMissingInterval"
                    type="number"
                  />
                </div>
              </div>
            </Col>
            <Col xs="12" sm="5" className="form">
              <div className="form__form-group">
                <span className="form__form-group-label">
                  {t('inference_services.inference_label.collection_name')}
                </span>
                <div className="form__form-group-field">
                  <Field
                    component={renderAutocomplete}
                    t={t}
                    collections={collections}
                    name="collection_name"
                    placeholder="Collection"
                    loadCollections={loadCollections}
                    onLabelItemSelect={onLabelItemSelect}
                  />
                </div>
              </div>

              <div className="form__form-group">
                <span className="form__form-group-label">
                  {t('inference_services.inference_label.activity_status')}
                </span>
                <div className="form__form-group-field">
                  <Field
                    component={renderSelectField}
                    name="activity_status"
                    type="select"
                    options={ACTIVITY_STATUS_OPTIONS}
                  />
                </div>
              </div>

              <div className="form__form-group">
                <span className="form__form-group-label">
                  {t('inference_services.inference_label.storage_type')}
                </span>
                <div className="form__form-group-field">
                  <Field
                    component={renderSelectField}
                    name="storageType"
                    type="select"
                    options={STORAGE_TYPE_OPTIONS}
                  />
                </div>
              </div>

              <Field
                component={renderField}
                name="inference_id"
                type="hidden"
              />

            </Col>
          </Row>

          {
            alModels &&
            <Row>
              <Col md={12}>
                <Card>
                  <CardHeader >
                    {t('inference_services.create_update_inference.select_ai_models_to_include')}
                  </CardHeader>
                  <CardBody>

                    <BootstrapTable
                      options={options}
                      data={alModels}
                      version="4"
                      hover
                      condensed
                      responsive
                      striped pagination
                      selectRow={ selectRowProp }
                      ref={ n => nodeTable = n }
                    >
                      <TableHeaderColumn dataField="name" width="160">
                        {t('inference_services.ai_models_label.ai_project_name')}
                      </TableHeaderColumn>
                      {/*<TableHeaderColumn
                        width="160"
                        dataField="_id"
                        dataFormat={() => <Field name='abc' component={renderCheckBox} />}
                      >
                        {t('inference_services.ai_models_label.select_to_include_model')}
                      </TableHeaderColumn>*/}
                      <TableHeaderColumn width="160" dataField="monitoring_window" dataFormat={renderMonitoringWindow}>
                        {t('inference_services.ai_models_label.monitoring_window')}
                      </TableHeaderColumn>
                      <TableHeaderColumn width="160" dataField="execution_type" dataFormat={renderExecutionSelect}>
                        {t('inference_services.ai_models_label.execution_type')}
                      </TableHeaderColumn>
                      <TableHeaderColumn isKey dataField="_id" dataSort hidden={true}>
                        Id
                      </TableHeaderColumn>

                    </BootstrapTable>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          }

          <Row>
            <Col xs="12" sm="5" className="text-right">
              <div >
                <Button color="primary" disabled={submitting} type="submit">
                  Save
                </Button>
              </div>
            </Col>
            <Col xs="12" sm="5" className="text-left">
              <div >
                <Button color="primary" onClick={props.onCancel}>
                  Cancel
                </Button>
              </div>
            </Col>
          </Row>

        </CardBody>
      </form>
    </Card>
  );
};

function mapStateToProps(state, ownProps) {
  const { inference } = state;
  const alModels = inference.alModels;
  let { form_data } = ownProps;
  let formData = {};

  form_data =
    form_data && Object.keys(form_data).length > 0
      ? form_data : formData;
  console.log({
    state, formData
  })
  const hasInference = form_data && Object.keys(form_data).length > 0;
  let parent_inference = state.inference.selectedInference;

  form_data.collection_id = parent_inference && parent_inference.collection_id;

  if (form_data && form_data.formType && form_data.formType === "clone") {
    delete form_data._id;
  }

  const collections = state.collections;

  return {
    initialValues: form_data,
    collections,
    hasInference,
    alModels,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      loadCollections,
      setExecutionType,
      change
    },
    dispatch
  );
}

let InferenceData = reduxForm({
  validate: validate,
  form: "InferenceForm",
  enableReinitialize: true
})(InferenceForm);

export default withTranslation('common') (connect(state => mapStateToProps, mapDispatchToProps)(InferenceData));
